import * as Actions from './actions.js';

export function accountReducer(state = null, action) {
  switch (action.type) {
    case Actions.ACCOUNT_DATA_TERMINATE_LOADING:
      return action.account;
    case Actions.ACCOUNT_UPDATED:
      return action.account;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/SFAccountService/reducers.js